import { ProductCustomizerAction, ProductCustomizerState } from "../types/ProductCustomizer";

export function ProductCustomizerReducer(state: ProductCustomizerState, action: ProductCustomizerAction): ProductCustomizerState {
  switch (action.type) {
    case "activeModal":
      return { ...state, activeModal: action.value }
    case "flow":
      return { ...state, flow: action.value }
    case "steps":
      return { ...state, steps: action.value }
    case "activeStep":
      return { ...state, activeStep: action.value }
    case "cameraIntro":
      return {...state, cameraIntro: action.value}
    case "variant":
      return { ...state, variant: action.value }
    case "resetSelectedOptions":
      return { ...state, selectedOptions: action.value }
    case "selectedOptions":
      return { ...state, selectedOptions: [...state.selectedOptions.map((el, i) => i === action.index ? action.value : el)] }
    case "updatedOption":
      return { ...state, updatedOption: action.value }
    case "cartNote":
      return { ...state, cartNote: action.value }
    case "orderNo":
      return { ...state, orderNo: action.value }
    case "updateImage":
      return { ...state, images: { ...state.images, [action.key]: action.value } }
    default:
      throw new Error();
  }
}